module.exports = __webpack_public_path__ + "img/search.e5866bf3.svg";